import React, { useState } from "react";
import "./Header.css";
import logo from "../assets/Dr Doodley Logo_Logo COLOR copy.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Hamburger */}
        <button
          className="hamburger-menu"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        {/* Logo */}
        <img src={logo} alt="Dr. Doodley Logo" className="header-logo" />

        {/* Call Now Button */}
        <button
          onClick={() => {
            window.open("tel:+91 9902356133");
          }}
          className="call-now-btn"
        >
          <span>CALL NOW</span>
        </button>
      </div>

      {/* Mobile Nav */}
      <nav className={`mobile-nav ${isMenuOpen ? "open" : ""}`}>
        <button
          className="close-btn"
          onClick={toggleMenu}
          aria-label="Close menu"
        >
          &times;
        </button>
        <ul className="nav-links">
          <li>
            <a
              href="https://doodley.in/vetathome/bangalore"
              onClick={toggleMenu}
            >
              Vet Home Visit
            </a>
          </li>
          <li>
            <a
              href="https://doodley.in/HomeVaccinationbangalore"
              onClick={toggleMenu}
            >
              Home vaccination
            </a>
          </li>
          <li>
            <a
              href="https://doodley.in/petclinicbangalore"
              onClick={toggleMenu}
            >
              Our Hospital
            </a>
          </li>
          <li>
            <a
              href="#phone"
              onClick={() => {
                window.open("tel:+91 9902356133");
              }}
              className="call-now-btn-mobile"
            >
              CALL NOW
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
